import { useEffect, useState } from 'react';

export default function ScoreDisplay({ score = 0, color = '#1D6B4F', size = 'large' }) {
  const [animatedScore, setAnimatedScore] = useState(0);

  useEffect(() => {
    let frame;
    const duration = 1200;
    const startTime = performance.now();

    const animate = (currentTime) => {
      const elapsed = currentTime - startTime;
      const progress = Math.min(elapsed / duration, 1);
      const eased = 1 - Math.pow(1 - progress, 3);
      setAnimatedScore(Math.round(eased * score));
      if (progress < 1) {
        frame = requestAnimationFrame(animate);
      }
    };

    frame = requestAnimationFrame(animate);
    return () => cancelAnimationFrame(frame);
  }, [score]);

  const isLarge = size === 'large';
  const svgSize = isLarge ? 180 : 100;
  const strokeWidth = isLarge ? 6 : 4;
  const radius = (svgSize - strokeWidth) / 2;
  const circumference = 2 * Math.PI * radius;
  const progress = (animatedScore / 100) * circumference;

  return (
    <div className="relative inline-flex items-center justify-center" data-testid="score-display">
      <svg width={svgSize} height={svgSize} className="-rotate-90">
        <circle
          cx={svgSize / 2}
          cy={svgSize / 2}
          r={radius}
          fill="none"
          stroke="#D4C9B8"
          strokeWidth={strokeWidth}
        />
        <circle
          cx={svgSize / 2}
          cy={svgSize / 2}
          r={radius}
          fill="none"
          stroke={color}
          strokeWidth={strokeWidth}
          strokeLinecap="round"
          strokeDasharray={circumference}
          strokeDashoffset={circumference - progress}
          className="transition-all duration-1000 ease-out"
        />
      </svg>
      <div className="absolute inset-0 flex flex-col items-center justify-center">
        <span
          className={`font-semibold ${isLarge ? 'text-5xl' : 'text-3xl'}`}
          style={{ color: '#3C3226', fontFamily: "'DM Sans', sans-serif" }}
          data-testid="score-value"
        >
          {animatedScore}
        </span>
        <span className={`${isLarge ? 'text-sm' : 'text-xs'} mt-1`} style={{ color: '#8C7E6E' }}>out of 100</span>
      </div>
    </div>
  );
}
